<div bsModal #GenericProgress="bs-modal" class="modal  fade" tabindex="-1" role="dialog"
    aria-labelledby="GenericProgress" aria-hidden="true" [config]="{backdrop: 'static'}">
    <div class="modal-dialog modal-lg modalCenter">
        <div class="col-5 m-auto modal-content pb-4 pl-4 pr-4 pt-3">

            <div class="text-center">

                <img src="../../../../assets/accounts/importAccounts/data-transfer.svg" /><br /><br />
                <h6 class="font-weight-bold"> {{progressHeader}}</h6>
                <h6> {{ProgressDetail}}</h6>
                <h6 *ngIf="progress>=0"> {{progress}}%</h6> 
                <div class="mt-3 progress">
                    <div class="progress-bar" role="progressbar" [ngStyle]="{ 'width': progress + '%' }"></div>
                </div> 
            </div>
        </div>
    </div>
</div>